module.exports = __webpack_public_path__ + "media/images/gcal-icon-9d176e98440a969e5cd63dd5e27f71cc22ab5c07fb6a5d3d390cff814401e8d3.jpg";